t = require('views/internal/teacup-with-helpers')('popover_share')
getExperiment = require 'lib/experiments/simple-test'

module.exports = t.renderable ({ hasCsvExport, csvURL, jsonURL, needsUpgradeForCsv, upgradeUrl, hasOrganization, upsellEnabled, isAdDismissed }) ->
  adsLayoutExperimentEnabled = getExperiment('adsLayout').get('enabled')

  t.ul '.pop-over-list', ->

    t.li ->
      t.a '.js-print', { href: '#', title: t.l('print-using-the-browser-s-print-function-you-can-use-file') }, ->
        t.format 'print-ellipsis'

    t.li =>
      if hasCsvExport
        t.a '.js-export-csv', { href: csvURL, title: t.l('export-the-board-data-in-csv-format') }, ->
          t.format 'export-csv'
      else
        t.a '.disabled', { href: '#', title: t.l('export-the-board-data-in-csv-format') }, ->
          t.format 'export-csv'

    t.li ->
      t.a '.js-export-json', { href: jsonURL, title: t.l('export-the-board-data-in-json-format') }, ->
        t.format 'export-json'

    if !hasCsvExport && upsellEnabled
      if adsLayoutExperimentEnabled
        if !isAdDismissed
          t.div '.popover-share-ads-container', =>
            t.hr()
            t.div '.popover-share-ads.ads-layout-experiment', =>
              t.div '.ad-header', =>
                if needsUpgradeForCsv
                  t.div '.title', ->
                    t.format 'ads-title-old-bc'
                else
                  t.div '.title', ->
                    t.format 'ads-title'

                t.div '.close-ad.js-close-ad', ->
                  t.span '.icon-sm.icon-close'

              t.p '.ads-links', =>
                if hasOrganization
                  t.a '.ads-link.js-upgrade-team', { href: upgradeUrl }, ->
                    t.format 'ads-upgrade'
                else
                  t.a '.ads-link.js-add-to-team', { href: '#' }, ->
                    t.format 'ads-upgrade'

                t.span '.divider', -> t.text '•'

                t.a '.ads-link.js-learn-more', { href: '/business-class' }, ->
                  t.format 'ads-learn-more'
      else
        t.hr()
        if needsUpgradeForCsv
          t.a { href: upgradeUrl }, ->
            t.format 'there-s-an-update-to-business-class-available-with-csv-export'
        else
          t.format 'looking-for-csv-export-check-out-business-class'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_share.coffee